var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.98999C10.5523 9.98999 11 10.4399 11 10.995V17.025C11 17.5801 10.5523 18.03 10 18.03C9.44772 18.03 9 17.5801 9 17.025V10.995C9 10.4399 9.44772 9.98999 10 9.98999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.98999C14.5523 9.98999 15 10.4399 15 10.995V17.025C15 17.5801 14.5523 18.03 14 18.03C13.4477 18.03 13 17.5801 13 17.025V10.995C13 10.4399 13.4477 9.98999 14 9.98999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C16.6292 2 17.9502 3.32757 17.9502 4.96496V5.96997H21C21.5523 5.96997 22 6.41992 22 6.97497C22 7.53002 21.5523 7.97998 21 7.97998H19.9502V18.03C19.9502 20.2225 18.1815 22 16 22H8C5.81848 22 4.0498 20.2225 4.0498 18.03V7.97998H3C2.44772 7.97998 2 7.53002 2 6.97497C2 6.41992 2.44772 5.96997 3 5.96997H6.0498V4.96496C6.04981 3.32757 7.37076 2 9 2H15ZM5.9502 18.03C5.9502 19.1679 6.86782 20.0901 8 20.0901H16C17.1322 20.0901 18.0498 19.1679 18.0498 18.03V7.97998H5.9502V18.03ZM9 3.9099C8.4201 3.9099 7.9502 4.38216 7.9502 4.96496V5.96997H16.0498V4.96496C16.0498 4.38216 15.5799 3.9099 15 3.9099H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2ba3184aa20258558724ef69b23618df.svg";
export { ForwardRef as ReactComponent };